import { ColDef } from 'ag-grid-community';
import { FormGroup } from "@angular/forms";

export function formatDateWithTime(value: any): string {
  if (value) {
    const date = new Date(value);
    return date.toLocaleString();
  }
  return '';
}

export function areJSONEqual(json1: JSON, json2: JSON) {
  return JSON.stringify(json1) === JSON.stringify(json2);
}

export function createColumn(headerName: string, field: string, extraProps: Partial<ColDef> = {}): ColDef {
  return { headerName, field, filter: true, floatingFilter: true, ...extraProps };
}

export function createNameColumn(headerName: string, userField: string): ColDef {
  return {
    headerName,
    valueGetter: (params) => {
      const user = params.data[userField];
      return user ? `${user.name} ${user.last_name}` : '';
    },
    filter: true,
    floatingFilter: true
  };
}

export function createDateColumn(headerName: string, field: string, floatingFilter = false): ColDef {
  return {
    headerName,
    field,
    valueFormatter: (params: any) => formatDateWithTime(params.value),
    filter: 'agDateColumnFilter',
    floatingFilter,
    filterParams: {
      filterOptions: ['equals', 'inRange'],
      comparator: (filterDate: any, cellValue: any) => dateComparator(filterDate, cellValue),
    },
  };
}

export function dateComparator(filterDate: Date, cellValue: any): number {
  const cellDate = new Date(cellValue);
  return cellDate < filterDate ? -1 : cellDate > filterDate ? 1 : 0;
}

// Utility function to trim all form values
export function trimFormValues(form: FormGroup) {
  Object.keys(form.controls).forEach(key => {
    const control = form.get(key);
    if (control && control.value && typeof control.value === 'string') {
      control.setValue(control.value.trim(), {emitEvent: false});
    }
  });
}

export function removeEmptyValues(payload: any) {
  for (const key in payload) {
    if (payload.hasOwnProperty(key)) {
      if (payload[key] === null || payload[key] === undefined || payload[key] === "") {
        delete payload[key];
      }
    }
  }
  return payload;
}

export function isMobileDevice(): boolean {
  return window.innerWidth < 768; // Common mobile breakpoint
}
